import React, { useEffect, useState, useRef } from "react";
import { Dropdown, Nav, Toast } from "react-bootstrap";
import { Link } from "react-router-dom";
import {getLastSession,getLastUser} from '../Data/SessionData.js';

export default function NavbarMenu(props) {

  const [sideMenuTab, setSideMenuTab] = useState([true]);
  const [isMenuVisible, setIsMenuVisible] = useState(false);

const userInfo = getLastUser();
const {
  isToastMessage,
  activeKey,
} = props;

useEffect(() => {
  activeMenutabwhenNavigate("/" + activeKey);
}, []);

const toggleMenu = () => {
  setIsMenuVisible(!isMenuVisible);
};

  function activeMenutabwhenNavigate(activeKey) {
    if (
      activeKey === "/dashboard"
    ) {
      activeMenutabContainer("dashboradContainer");
    } else if (
      activeKey === "/mrstatus"
    ) {
      activeMenutabContainer("UIElementsContainer");
    } else if (
      activeKey === "/controls"
    ) {
      activeMenutabContainer("UIElementsContainer3");
    } else if (
      activeKey === "/elevatorstatus"
    ) {
      activeMenutabContainer("UIElementsContainer2");
    } else if (activeKey === "/login") {
      activeMenutabContainer("WidgetsContainer");
    } else if (
      activeKey === "/profilev1page" 
    ) {
      activeMenutabContainer("PagesContainer");
    }
  }

  function activeMenutabContainer(id) {
    var parents = document.getElementById("main-menu");
    var activeMenu = document.getElementById(id);
    for (let index = 0; index < parents.children.length; index++) {
      if (parents.children[index].id !== id) {
        parents.children[index].classList.remove("active");
        parents.children[index].children[1].classList.remove("in");
      }
    }
    setTimeout(() => {
      activeMenu.classList.toggle("active");
      activeMenu.children[1].classList.toggle("in");
    }, 10);
  }

    return (
      <div>
        {isToastMessage ? (
          <Toast
            id="toast-container"
            show={isToastMessage}
            onClose={() => {
              props.tostMessageLoad(false);
            }}
            className="toast-info toast-top-right"
            autohide={true}
            delay={2000}
          >
            <Toast.Header className="toast-info mb-0">
              Welcome to HiOctane Labs Portal.
            </Toast.Header>
          </Toast>
        ) : null}
        <nav className="navbar navbar-fixed-top">
          <div className="container-fluid">
            <div>
            <button onClick={toggleMenu} className="menu-toggle">
              ☰
            </button>
            {isMenuVisible &&
            <Nav id="mobile-sidebar-nav" className="sidebar-nav">
                  <ul id="main-menu" className="metismenu">
                    <li className="" id="dashboradContainer">
                      <a
                        href="#!"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          activeMenutabContainer("dashboradContainer");
                          console.log("Now navigating to ","dashboard");
                          window.location = "dashboard";                    
                        }}
                      >
                        <i className="icon-home"></i> <span>Dashboard</span>
                      </a>
                      <ul className="collapse">
                      </ul>
                    </li>
                    <li id="AppContainer" className="">
                      <a
                        href="#!"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          activeMenutabContainer("AppContainer");
                          window.location = "myalertspage";
                        }}
                      >
                        <i className="icon-grid"></i> <span>Alerts & Warnings</span>
                      </a>
                      <ul className="collapse">
                      </ul>
                    </li>
                    <li id="FileManagerContainer" className="">
                      <a
                        href="#!"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          activeMenutabContainer("FileManagerContainer");
                        }}
                      >
                        <i className="icon-folder"></i>{" "}
                        <span>Drive Status</span>
                      </a>
                      <ul className="collapse">
                      </ul>
                    </li>
                    <li id="UIElementsContainer2" className="">
                      <a
                        href="#uiElements2"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          activeMenutabContainer("UIElementsContainer2");
                          console.log("Now navigating to ","Elevator Status");
                          window.location = "elevatorstatus";                    
                        }}
                      >
                        <i className="icon-globe"></i>{" "}
                        <span>Elevator Status</span>
                      </a>
                      <ul className="collapse">
                      </ul>
                    </li>                    
                    <li id="UIElementsContainer" className="">
                      <a
                        href="#uiElements"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          activeMenutabContainer("UIElementsContainer");
                          console.log("Now navigating to ","MR Status");
                          window.location = "mrstatus";                    
                        }}
                      >
                        <i className="icon-diamond"></i>{" "}
                        <span>MR Status</span>
                      </a>
                      <ul className="collapse">
                      </ul>
                    </li>                    
                    <li id="UIElementsContainer3" className="">
                      <a
                        href="#uiElements3"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          activeMenutabContainer("UIElementsContainer3");
                          console.log("Now navigating to ","Controls");
                          window.location = "controls";                    
                        }}
                      >
                        <i className="icon-diamond"></i>{" "}
                        <span>Controls</span>
                      </a>
                      <ul className="collapse">
                      </ul>
                    </li>  
                  </ul>
                </Nav>        
                }    
            </div>
            <div className="navbar-brand">
              <a href="dashboard">
                <img
                  src="images/logo.png"
                  alt="Lucid Logo"
                  className="img-responsive logo"
                />
              </a>
            </div>

            <div className="navbar-right">
              <div id="navbar-menu">
                <ul className="nav navbar-nav">
                  {userInfo.userType &&
                  <li>
                    You are logged-in as <b>{userInfo.userType}</b>.
                  </li>
                  }
                  <li>
                    <a href="login" className="icon-menu">
                      <i className="icon-login"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
        <div id="left-sidebar" className="sidebar" style={{ zIndex: 9 }}>
          <div className="sidebar-scroll">
            <div className="user-account">
              <img
                src="images/user.png"
                className="rounded-circle user-photo"
                alt="User Profile"
              />
              <Dropdown>
                <span>Welcome,</span>
                <Dropdown.Toggle
                  variant="none"
                  as="a"
                  id="dropdown-basic"
                  className="user-name"
                >
                  <strong>{userInfo.firstName}&nbsp;{userInfo.lastName}</strong>
                </Dropdown.Toggle>

                <Dropdown.Menu className="dropdown-menu-right account">
                  <Dropdown.Item href="myprofilepage">
                    <i className="icon-user"></i>My Profile
                  </Dropdown.Item>
                  <Dropdown.Item href="mysettingspage">
                    {" "}
                    <i className="icon-settings"></i>Settings
                  </Dropdown.Item>
                  <Dropdown.Item href="mymapspage">
                    {" "}
                    <i className="icon-globe"></i>Location Map
                  </Dropdown.Item>
                  <li className="divider"></li>
                  <Dropdown.Item href="login">
                    {" "}
                    <i className="icon-power"></i>Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <hr />
            </div>
            <ul className="nav nav-tabs">
              <li className="nav-item">
                <Link
                  to="#"
                  className={"nav-link active"}
                  data-toggle="tab"
                  onClick={() => {
                    props.onPressSideMenuTab(0);
                  }}
                >
                  Menu
                </Link>
              </li>
            </ul>
            <div className="tab-content p-l-0 p-r-0">
              <div
                className={"tab-pane active show"}
                id="menu"
              >
                <Nav id="left-sidebar-nav" className="sidebar-nav">
                  <ul id="main-menu" className="metismenu">
                    <li className="" id="dashboradContainer">
                      <a
                        href="#!"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          activeMenutabContainer("dashboradContainer");
                          console.log("Now navigating to ","dashboard");
                          window.location = "dashboard";                    
                        }}
                      >
                        <i className="icon-home"></i> <span>Dashboard</span>
                      </a>
                      <ul className="collapse">
                      </ul>
                    </li>
                    <li id="AppContainer" className="">
                      <a
                        href="#!"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          activeMenutabContainer("AppContainer");
                          window.location = "myalertspage";
                        }}
                      >
                        <i className="icon-grid"></i> <span>Alerts & Warnings</span>
                      </a>
                      <ul className="collapse">
                      </ul>
                    </li>
                    <li id="FileManagerContainer" className="">
                      <a
                        href="#!"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          activeMenutabContainer("FileManagerContainer");
                        }}
                      >
                        <i className="icon-folder"></i>{" "}
                        <span>Drive Status</span>
                      </a>
                      <ul className="collapse">
                      </ul>
                    </li>
                    <li id="UIElementsContainer2" className="">
                      <a
                        href="#uiElements2"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          activeMenutabContainer("UIElementsContainer2");
                          console.log("Now navigating to ","Elevator Status");
                          window.location = "elevatorstatus";                    
                        }}
                      >
                        <i className="icon-globe"></i>{" "}
                        <span>Elevator Status</span>
                      </a>
                      <ul className="collapse">
                      </ul>
                    </li>                    
                    <li id="UIElementsContainer" className="">
                      <a
                        href="#uiElements"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          activeMenutabContainer("UIElementsContainer");
                          console.log("Now navigating to ","MR Status");
                          window.location = "mrstatus";                    
                        }}
                      >
                        <i className="icon-diamond"></i>{" "}
                        <span>MR Status</span>
                      </a>
                      <ul className="collapse">
                      </ul>
                    </li>                    
                    <li id="UIElementsContainer3" className="">
                      <a
                        href="#uiElements3"
                        className="has-arrow"
                        onClick={(e) => {
                          e.preventDefault();
                          activeMenutabContainer("UIElementsContainer3");
                          console.log("Now navigating to ","Controls");
                          window.location = "controls";                    
                        }}
                      >
                        <i className="icon-diamond"></i>{" "}
                        <span>Controls</span>
                      </a>
                      <ul className="collapse">
                      </ul>
                    </li>                    
                  </ul>                  
                </Nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
}
